export default __webpack_public_path__ + "static/media/jobseeker_1.3a8bfb2f.png";